import React from 'react'

import { Colors } from '@/common/constants'

import { Icon } from '../Icon'

interface BountiesIconProps {
  className?: string
}

export const BountiesIcon = React.memo(({ className }: BountiesIconProps) => (
  <Icon
    size="16"
    viewBox="0 0 24 24"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    color="currentColor"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1237 3.82352C11.336 3.78866 10.5964 3.91355 10.0937 4.20857C9.1124 4.7844 7.92685 4.68075 7.01651 4.48378C6.89668 4.45786 6.77747 4.42927 6.65977 4.3988L8.12656 7.62668L7.90161 8.7174C5.81236 10.5564 4.7234 13.3462 4.7234 16.7183C4.7234 18.0764 5.47377 19.1613 6.82385 19.9536C8.18792 20.7541 10.0679 21.1821 12 21.1821C13.9321 21.1821 15.8121 20.7541 17.1762 19.9536C18.5262 19.1613 19.2766 18.0764 19.2766 16.7183C19.2766 13.4727 18.2679 10.7667 16.3294 8.92847H10.2561V7.11062H16.0445L17.1118 3.97927L14.4273 4.31683L13.9395 4.22703C13.5957 4.04549 12.9107 3.85835 12.1237 3.82352ZM17.6586 7.74841C19.9106 9.9885 21 13.1591 21 16.7183C21 18.942 19.7158 20.5435 18.014 21.5422C16.3262 22.5326 14.137 23 12 23C9.86299 23 7.67378 22.5326 5.98599 21.5422C4.28421 20.5435 3 18.942 3 16.7183C3 13.1848 4.07371 10.0343 6.29283 7.79705L4.24727 3.29549L5.29716 2.04047C5.40909 2.07988 5.52967 2.12425 5.65771 2.17138C6.14087 2.34921 6.73035 2.56616 7.36282 2.70301C8.18669 2.88127 8.84192 2.86288 9.2558 2.62001C10.1482 2.09632 11.2494 1.96537 12.196 2.00726C13.0239 2.0439 13.8482 2.21823 14.4601 2.48197L18.2924 2.00009L19.2053 3.21012L17.6586 7.74841Z"
      fill={Colors.Black[900]}
    />
    <path
      d="M7.94449 13.0532V15.7224C7.94037 16.0228 7.80442 16.1787 7.549 16.1787C7.2977 16.1787 7.15764 16.0247 7.14528 15.73H6.00002C5.9959 16.6274 6.66328 17 7.47485 17C8.41001 17 9.06915 16.4829 9.07327 15.7224V13.0532H7.94449Z"
      fill={Colors.Blue[500]}
    />
    <path
      d="M13.7027 15C13.7027 13.6996 12.7964 13 11.6511 13C10.4976 13 9.59955 13.6996 9.59955 15C9.59955 16.2928 10.4976 17 11.6511 17C12.7964 17 13.7027 16.3004 13.7027 15ZM12.5245 15C12.5245 15.6996 12.2196 16.0798 11.6511 16.0798C11.0826 16.0798 10.7778 15.6996 10.7778 15C10.7778 14.3004 11.0826 13.9202 11.6511 13.9202C12.2196 13.9202 12.5245 14.3004 12.5245 15Z"
      fill={Colors.Blue[500]}
    />
    <path
      d="M13.765 13.0532L15.314 15.7224V16.9468H16.451V15.7224L18 13.0532H16.7229L15.899 14.635H15.866L15.0421 13.0532H13.765Z"
      fill={Colors.Blue[500]}
    />
  </Icon>
))
